var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import React, { createContext, useContext } from 'react';
import { ChainIds } from '@sovryn/ethers-provider';
import { DATA_REFRESH_INTERVAL } from '../constants/general';
import { useCurrentChain } from '../hooks/useChainStore';
import { loadIndexer } from '../lib/indexer';
import { decimalic } from '../utils/math';
const UNSUPPORTED_CHAIN_IDS = [
    ChainIds.MAINNET,
    ChainIds.SEPOLIA,
    ChainIds.BSC_MAINNET,
    ChainIds.BSC_TESTNET,
];
const TokenPricesContext = createContext(undefined);
export const TokenPricesProvider = ({ children, }) => {
    const currentChainId = useCurrentChain();
    const { data, isFetching } = useQuery({
        queryKey: ['tokenPrices', currentChainId],
        initialData: {},
        placeholderData: keepPreviousData,
        refetchInterval: DATA_REFRESH_INTERVAL,
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            // Fallback to RSK_MAINNET if current chain is unsupported
            const chain = UNSUPPORTED_CHAIN_IDS.includes(currentChainId)
                ? ChainIds.RSK_MAINNET
                : currentChainId;
            const data = yield loadIndexer(chain).tokens.list();
            if (data) {
                const prices = data.reduce((acc, tokenData) => {
                    acc[tokenData.address.toLowerCase()] = decimalic(tokenData.usdPrice).toString();
                    return acc;
                }, {});
                return prices;
            }
            throw new Error('No token prices data');
        }),
    });
    return (React.createElement(TokenPricesContext.Provider, { value: { prices: data, loading: isFetching } }, children));
};
export const useTokenPrices = () => {
    const context = useContext(TokenPricesContext);
    if (!context) {
        throw new Error('useTokenPrices must be used within a TokenPricesProvider');
    }
    return context;
};
